/**
 * Hidden honeypot field: bots fill it in, humans never see it (absolute
 * off-screen). `name` must stay semantically meaningless - a name that looks
 * like a real field is one browser autofill will fill (see HONEYPOT_FIELDS).
 *
 * Deliberately controlled: the forms submit JSON built in JavaScript, not a
 * native form post, so an uncontrolled input would never reach the server - * it would look like a defense without being one. The value must be included
 * in the payload; the route silently drops the submission if it's filled in.
 */
export function Honeypot({
  name,
  value,
  onChange,
}: {
  name: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <input
      type="text"
      name={name}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      autoComplete="off"
      tabIndex={-1}
      aria-hidden="true"
      className="absolute -left-2499.75 h-0 w-0 overflow-hidden opacity-0"
    />
  );
}
